import { useQuery } from "@tanstack/react-query";
import { listCoaches } from "@/lib/admin/concierge-insights-api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function CoachPicker({
  orgId,
  value,
  onChange,
}: {
  orgId: string;
  value: string | null;
  onChange: (v: string | null) => void;
}) {
  const { data: coaches = [], isLoading } = useQuery({
    queryKey: ["concierge", "admin", "coaches", orgId],
    queryFn: () => listCoaches(orgId),
    staleTime: 60_000,
  });

  return (
    <Select
      value={value ?? "__none__"}
      onValueChange={(v) => onChange(v === "__none__" ? null : v)}
    >
      <SelectTrigger>
        <SelectValue placeholder={isLoading ? "Loading…" : "Unassigned"} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">Unassigned</SelectItem>
        {coaches.map((c) => (
          <SelectItem key={c.user_id} value={c.user_id}>
            {c.handle}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default CoachPicker;
